export const PROMOCODE_SECTION_QUERY = 'promocode';
export const DISTANCE_TO_TOP = 100;
